<template>
      <div class="modal fade" id="importServiceListModal" tabindex="-1" aria-labelledby="importServiceListModal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Importer un bordereau de prestation</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="searchServiceListInput">Prestation <span v-b-tooltip="'Vous pouvez rechercher par le nom du bordereau de prestation'">
                                        <i class="fas fa-question-circle"></i></span></label>
                                    <input type="text" class="form-control form-control" placeholder="Commencer la saisie pour obtenir des suggestions .." id="searchServiceListInput" name="searchServiceListInput" v-model="searchService.designation">
                                </div>
                                 <div class="form-group" v-if="searchService.id">
                                    <label for="original_quantity">Quantité initiale de la prestation<span v-if="searchService.unit"> en {{ searchService.unit }}</span></label>
                                    <input type="number" class="form-control" name="original_quantity" id="original_quantity" v-model="originalQuantity" disabled>
                                </div>
                                <div class="form-group" v-if="searchService.id">
                                    <label for="quantity" class="required">Quantité souhaitée de la prestation<span v-if="searchService.unit"> en {{ searchService.unit }}</span></label>
                                    <input type="number" class="form-control" name="quantity" id="quantity" step="0.001" v-model="quantity" @blur="compute">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12" v-if="lines && lines.length > 0">
                                <h2 class="ix-page-title-secondary mt-2">Prévisualisation</h2>
                                    <div class="ix-table-box mt-4">
                                        <table class="ix-table">
                                            <thead>
                                                <tr> 
                                                    <th>Catégorie</th>
                                                    <th>Ref.</th>
                                                    <th>Désignation</th>
                                                    <th class="text-center">Qté initiale</th>
                                                    <th class="text-center">Qté souhaitée</th>
                                                    <th class="text-right">Prix de revient HT</th>
                                                    <th class="text-right">Prix de vente HT</th>
                                                    <th class="text-right">Total vente HT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(line, index) in lines" :key="index">
                                                    <td>{{ getLabelTypePrediction(line.type) }}</td>
                                                     <td>{{ line.reference }}</td>
                                                    <td>
                                                        <span class="ix-text-secondary mr-1" v-if="line.is_hidden_from_client" v-b-tooltip.hover title="Ligne masquée dans le devis"><i class="far fa-eye-slash"></i></span>
                                                        <span v-if="line.article_id"><i class="far fa-cube"></i></span>
                                                        <span v-html="truncate(line.designation, 20)"></span>
                                                        <span class="badge badge-secondary ml-1" v-if="line.unit === 'forfait'">Forfait</span>
                                                    </td>
                                                    <td class="text-center">
                                                        <input type="number" class="form-control" v-model="originalLines[index].quantity" min="1" step="0.001" @blur="compute" :disabled="line.unit === 'forfait'"/>
                                                    </td>
                                                    <td class="text-center">
                                                        <input type="number" class="form-control" v-model="line.quantity" min="0" step="0.001" @blur="computeLine(index)"/>
                                                    </td>
                                                    <td class="text-right">{{ currency(line.amount) }}</td>
                                                    <td class="text-right">{{ currency(line.selling) }}</td>
                                                    <td class="text-right">
                                                        {{ currency(line.total_selling) }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="text-right ix-text-large ix-text-bold" colspan="8">{{ currency(total_selling) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="ix-btn green" v-bind:disabled="!checkForm()" @click="injectService">Injecter</button>
                    </div>
                </div>
            </div>
      </div>
</template>


<script>
export default {
    name: 'ImportServiceList',
    props: ['serviceUrl', 'predictionTypes', 'purchaseTypes', 'typeMargin'],
    data() {
        return {
            searchService: {
                designation : '',
                id: null,
                unit: null,
            },
            lines: [],
            originalLines: [],
            margin_type: this.typeMargin,
            quantity: null,
            originalQuantity: null,
            typePredictions: this.predictionTypes,
            typePurchases : this.purchaseTypes,
        }
    },
    methods: {
        injectService(){
             this.$emit('inject-service-list', {
                    'serviceList' : this.searchService,
                    'predictions' : this.lines,
                    'wishQuantity' : this.quantity
            });

            this.clear();
            $('#importServiceListModal').modal('hide')
        },
        clear(){
            this.originalLines = [];
            this.lines = [];
            this.quantity = null;
            this.originalQuantity = null;
            this.searchService.id = null;
            this.searchService.designation = '';
            this.searchService.unit = null;
        },
        getLabelTypePrediction(value){
            return this.typePredictions.filter(prediction => {
                return prediction.value == value;
            })[0].label;
        },
        checkForm(){
            return this.quantity != null && this.quantity != '' && this.lines.length > 0;
        },
        compute(){
            this.lines.forEach((line,index) => {
                if (line.unit === 'forfait') {
                    line.quantity = 1;
                    line.total_selling = parseFloat(line.selling);
                    return;
                }

                line.quantity =  this.roundCurrency((this.quantity * this.originalLines[index].quantity) / this.originalQuantity, 2);
                line.total_selling = parseFloat(line.quantity) * parseFloat(line.selling)
            });
        },
        computeLine(index){
            const line = this.lines[index];

            if (line.quantity === '' || line.quantity === null) { line.quantity = 0 }

            line.total_selling = parseFloat(line.quantity) * parseFloat(line.selling);
        },
    },
    computed: {
        total_selling: function(){
            var sum = 0;
            this.lines.forEach(line => sum += parseFloat(line.total_selling));
            return sum;
        }
    },
    mounted(){  
         $("#searchServiceListInput").autocomplete({
             minLength: 2,
             source: (request, response) => {
                 $.ajax({
                    url: this.serviceUrl,
                    type: 'get',
                    dataType : 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { q: request.term },
                    success: (data) => {
                        response($.map(data, (item) => {
                            return Object.assign(item, {
                                label: item.designation,
                                value: item.designation,
                                formatted_selling: this.currency(item.total_selling)
                            })
                        }))
                    }
                 })
             },
             create: function(){
                 $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                     var html = `<div class="d-flex align-items-center">
                                      <span>${item.designation}</span>
                                    <span class="ml-auto badge badge-secondary">${item.formatted_selling}</span>
                                </div>    
                                    <span class="ml-2 ix-state bordered">${item.service_list_group_designation}</span>`;

                    return $('<li>')
                            .append(html)
                            .appendTo(ul);
                 }
             },
            change: (e, item) => {
                if(!item.item){
                    $(e.target).val("");
                    this.searchService.designation = '';
                    this.searchService.id = null;
                     this.searchService.unit = null;
                    this.lines = [];
                }
            },
            select: (e,item) => {
                if(item.item){
                    this.searchService.designation = item.item.designation;
                    this.searchService.id = item.item.id;
                    this.searchService.unit = item.item.unit;
                    this.quantity = item.item.quantity;
                    this.lines = item.item.lines;
                    this.originalQuantity = item.item.quantity;
                    this.originalLines = _.cloneDeep(item.item.lines);
                }
            }
         }).focus(() => {
                $("#searchServiceListInput").autocomplete("search", '');
         });
    }   
}
</script>